import { Link } from 'react-router-dom';
import { Mail, Phone, User } from 'lucide-react';
import { Button, Card, CardContent } from '@leoclinic/ui';
import { useAuth, useMyClient, useClientPortalMutations } from '@leoclinic/hooks';
import { BRAND_COLORS } from '@leoclinic/types';
import { useClinicPortal } from '@/providers/clinic-provider';
import { useEffect } from 'react';

export default function AccountPage() {
  const { user, signOut } = useAuth();
  const { clinic } = useClinicPortal();
  const { data: client, isLoading, refetch } = useMyClient();
  const { linkProfile } = useClientPortalMutations();

  useEffect(() => {
    if (!isLoading && !client && user?.email) {
      linkProfile().then(() => refetch());
    }
  }, [isLoading, client, user?.email, linkProfile, refetch]);

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-bold" style={{ color: BRAND_COLORS.greenDark }}>
        Minha conta
      </h1>

      <Card className="border-[#ECECEC]">
        <CardContent className="pt-6 space-y-4">
          <div className="flex items-center gap-3">
            <div
              className="h-12 w-12 rounded-full flex items-center justify-center text-white font-semibold"
              style={{ backgroundColor: BRAND_COLORS.greenDark }}
            >
              {(client?.full_name ?? user?.full_name ?? '?').charAt(0).toUpperCase()}
            </div>
            <div>
              <p className="font-semibold">{client?.full_name ?? user?.full_name}</p>
              <p className="text-sm text-muted-foreground">Cliente — {clinic?.name ?? 'Clínica'}</p>
            </div>
          </div>

          <div className="space-y-2 text-sm">
            <p className="flex items-center gap-2 text-muted-foreground">
              <Mail className="h-4 w-4 shrink-0" />
              {user?.email}
            </p>
            {client?.phone && (
              <p className="flex items-center gap-2 text-muted-foreground">
                <Phone className="h-4 w-4 shrink-0" />
                {client.phone}
              </p>
            )}
            <p className="flex items-center gap-2 text-muted-foreground">
              <User className="h-4 w-4 shrink-0" />
              {client ? 'Conta ligada às suas marcações' : 'A ligar conta às marcações...'}
            </p>
          </div>
        </CardContent>
      </Card>

      <div className="flex flex-col gap-2">
        <Button asChild variant="outline">
          <Link to="/minhas-marcacoes">Ver minhas marcações</Link>
        </Button>
        <Button asChild>
          <Link to="/">Nova marcação</Link>
        </Button>
        <Button variant="ghost" onClick={handleSignOut} className="text-muted-foreground">
          Terminar sessão
        </Button>
      </div>
    </div>
  );
}
